import { render, staticRenderFns } from "./IconMoveBottom.vue?vue&type=template&id=7ba53f22&"
import script from "./IconMoveBottom.vue?vue&type=script&lang=js&"
export * from "./IconMoveBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ba53f22')) {
      api.createRecord('7ba53f22', component.options)
    } else {
      api.reload('7ba53f22', component.options)
    }
    module.hot.accept("./IconMoveBottom.vue?vue&type=template&id=7ba53f22&", function () {
      api.rerender('7ba53f22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconMoveBottom.vue"
export default component.exports